/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Triggers_Kind_Schedule_DescriptionInputs */



/**
* | output |
* | --- |
* | "Run at fixed times, like every weekday at 9:00." |
*
* @param {Agent_Triggers_Kind_Schedule_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_triggers_kind_schedule_description = /** @type {((inputs?: Agent_Triggers_Kind_Schedule_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Triggers_Kind_Schedule_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zu festen Zeiten ausführen, etwa werktags um 9:00.")
	return /** @type {LocalizedString} */ ("Run at fixed times, like every weekday at 9:00.")
});